import AuthFooterPrompt from 'pages/Auth/components/AuthFooterPrompt';
import type { AuthSignInFooterPromptProps } from './AuthSignInFooterPrompt.props';

const AuthSignInFooterPrompt = ({
  disabled = false,
  replace = false,
  to,
}: AuthSignInFooterPromptProps) => (
  <AuthFooterPrompt
    disabled={disabled}
    linkLabel="Sign in"
    prompt="Have an account?"
    replace={replace}
    to={to}
  />
);

export default AuthSignInFooterPrompt;
